import React from 'react';
import Basepage, { BasePageState } from '../Basepage';
import MolLink from '../Basepage/parts/Menu/MolLink';
import './Versand_all.scss';

interface VersandkostenState extends BasePageState {}
interface VersandkostenModel {
  versand: { alpha2: string; basis: string; kg: string; name: string };
}

export default class VersandkostenAllPage extends Basepage<
  VersandkostenState,
  VersandkostenModel
> {
  renderChild(): JSX.Element {
    return (
      <div id="VersandkostenAllPage">
        Dear Buchbutler customers,
        <br />
        <br />
        please note that we have adjusted our shipping costs. In future, you
        will pay a fixed base price for your destination country and additional
        a price per kilogramm.
        <br />
        <b>In addition, there is a handling fee of €0.75 per shipment.</b>
        <br />
        The prices for your country can be found in the list below.
        <br />
        <br />
        In order to save and optimise shipping costs, we would like to recommend
        that you define a shipping day in your customer account.
        <br />
        <br />
        <MolLink to="/konto/" href="/konto/">
          Please click here to go to your customer account settings.
        </MolLink>
        <br />
        We collect the items for you and ship them on the day of your choice.
        You then only pay the actual shipping costs and the handling fee once a
        week.
        <br />
        <br />
        The postage costs are charged separately and listed on a separate
        invoice.
        <br />
        <br />
        Do you have a delivery address in Germany?
        <br />
        The shipping costs for shipments within Germany can be found{' '}
        <a href="https://www.buchbutler.de/versandkosten" target="_blank">
          here
        </a>
        <br />
        <hr />
        <br />
        <br />
        Liebe Buchbutler Kundinnen und Kunden, <br />
        <br />
        bitte beachten Sie, dass wir unsere Versandkosten angepasst haben.
        <br />
        <br />
        Sie zahlen in Zukunft einen fixen Basispreis für Ihr Zielland und einen
        Kilopreis pro angefangenes Kilo.
        <br />
        <b>Des Weiteren eine Handlingsgebühr in Höhe von 0,75€ pro Sendung. </b>
        <br />
        Die Preise für Ihr Land finden Sie in der untenstehenden Liste.
        <br />
        <br />
        Um Portokosten zu sparen und zu optimieren, möchten wir Ihnen gerne
        empfehlen, in Ihrem Kundenkonto einen Versandtag festzulegen. <br />
        <br />
        <MolLink to="/konto/" href="/konto/">
          Bitte klicken Sie hier um zu Ihrem Kundenkonto zu kommen
        </MolLink>
        <br />
        Wir sammeln die Artikel für Sie und versenden an dem von Ihnen
        gewünschten Tag. Sie zahlen dann nur einmal pro Woche die tatsächlich
        angefallenen Portokosten und die Handlingsgebühr. <br />
        <br />
        Haben Sie eine Lieferadresse in Deutschland? Die Portokosten für eine
        Sendung innerhalb Deutschlands finden Sie{' '}
        <a href="https://www.buchbutler.de/versandkosten" target="_blank">
          hier
        </a>
        <br />
        <br />
        <table style={{ width: '100%', border: '1px solid black' }}>
          <thead>
            <tr>
              <th>Land</th>
              <th>Country</th>
              <th>Basispreis</th>
              <th>Preis je kg</th>
              <th>Beispiel 1kg</th>
              <th>Beispiel 3kg</th>
              <th>Beispiel 5kg</th>
            </tr>
          </thead>
          <tbody>
            {this.body.country.map((country: any) => {
              return (
                <tr key={country.Country}>
                  <td style={{ textAlign: 'left' }}>{country.Land}</td>
                  <td style={{ textAlign: 'left' }}>{country.Country}</td>
                  <td style={{ textAlign: 'right' }}>{country.Basispreis} €</td>
                  <td style={{ textAlign: 'right' }}>
                    {country.Preis_je_kg} €
                  </td>
                  <td style={{ textAlign: 'right' }}>
                    {country.Beispiel_1kg} €
                  </td>
                  <td style={{ textAlign: 'right' }}>
                    {country.Beispiel_3kg} €
                  </td>
                  <td style={{ textAlign: 'right' }}>
                    {country.Beispiel_5kg} €
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }
  initState(base: BasePageState): VersandkostenState {
    let newState: VersandkostenState = {
      ...base,
    };

    return newState;
  }
  getApiReqestUrl(checkOnly: boolean): string {
    return this.state.apiBase + '/Standard.php?include=versandkosten_all';
  }
  releaseOneCommand(): void {}
  childDidMount(): void {}
  childDidUnmount(): void {}
  initJSChild(): string {
    return '';
  }
  childDidUpdate(prevProp: any, prevState: any): void {}
  getRightBreadCrumbParts(): JSX.Element {
    return <></>;
  }

  pageHeaderGetter(): string | null {
    return null;
  }
  pageTitleGetter(): string {
    return 'Versandkosten';
  }
  getBreadCrumb(): JSX.Element {
    return <span>Versandkosten</span>;
  }
  getType(): string {
    return 'VersandkostenAllPage';
  }
}
